IntlMessageFormat.__addLocaleData({"locale":"ky","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ky-Cyrl","parentLocale":"ky"});
IntlMessageFormat.__addLocaleData({"locale":"ky-Cyrl-KG","parentLocale":"ky-Cyrl"});
